import React from 'react';

import Shsat from './Shsat';

async function action() {
  return {
    component: (
        <Shsat />    
    ),
  };
}

export default action;
